<div appMousedownOutside (mousedownOutside)="selectedMenuIcon=''">
    <div class="vis-menu">
        <app-vis-menu
            #visMenu
            [selectedMenuIcon]="selectedMenuIcon"
            [widgetId]="widgetId"
            [menuItems]="visMenuOptions"
            (selectVisualization)="onVisSelect($event)"
            (visualizationChanged)="onVisChanged($event)"
        >
        </app-vis-menu>
    </div>

    @if (selectedMenuIcon === 'custom-filter') {
        <app-dropdown
            [options]="filterOptions"
            [wrapperCssClass]="'hide-title'"
            [showDropdown]="selectedMenuIcon === 'custom-filter'"
            [(selected)]="selectedFilterOption"
            (selectedChange)="onFilterChanged($event)"
        >
        </app-dropdown>
    }
</div>
